export default "__VITE_PUBLIC_ASSET__e4f48c46__"